import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from "../components/common/react-notifications";
import FieldError from "../components/FieldError";
import Select from "react-select";
import Api from "../services/Api";
import {isEqual} from 'lodash';


class TokenTagsManageForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagOptions: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/tags', null, {
        params: {
          limit: 100
        },
      });
      this.setState({
        tagOptions: data.rows.map(item => ({label: item.name, value: item.id})),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  updateToken = async values => {
    const {t, token, afterSubmit} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/tokens/${token.symbol}`,
        {
          tags: values.tags.map(item => item.value),
        },
      );
      NotificationManager.success(t('Token {{symbol}} updated successfully', {symbol: token.symbol}), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  render() {
    const {t, token} = this.props;
    return(
      <FinalForm
        initialValues={{
          tags: token ? token.tags.map(item => ({label: item.name, value: item.id})) : undefined,
        }}
        onSubmit={this.updateToken}
        render={({handleSubmit, submitting, hasValidationErrors, values, initialValues}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col>
                  <span>
                   {t('Tags')}
                  </span>
                  <Field
                    name="tags"
                    component={this.ReactSelectAdapter}
                    options={this.state.tagOptions}
                  />
                  <FieldError name='tags' />
                </Col>
              </Row>
              <Row className='mt-5'>
                <Col>
                  <LoaderButton
                    color="success"
                    className="text-center"
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{minWidth: '100px'}}
                    disabled={hasValidationErrors || submitting || isEqual(values, initialValues)}>
                    {t('Update')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(TokenTagsManageForm);
